import React from "react"
import { createRequest } from "utils/request-helper"

class WithData extends React.Component {
  state = {
    data: undefined,
  }

  componentWillMount() {
    this.makeRequest(this.props.method, this.props.route, this.props.query)
  }

  componentWillReceiveProps(newProps) {
    this.setState({ data: undefined })
    this.makeRequest(newProps.method, newProps.route, newProps.query)
  }

  makeRequest(method = "GET", route, query) {
    createRequest(
      { method, route, query },
      response => this.setState({ data: response.data }),
      error => {
        console.error(error)

        if (error.response && error.response.status === 404) {
          this.setState({ data: null })
        }
      }
    )
  }

  render() {
    const { LoadingComponent } = this.props

    if (this.state.data === undefined) {
      return <LoadingComponent />
    } else if (this.state.data) {
      return React.cloneElement(this.props.children, {
        ...this.props.children.props,
        data: this.state.data,
      })
    }
  }
}

export default WithData



// WEBPACK FOOTER //
// ./src/containers/WithData/index.js